import React, { ReactElement } from 'react';

interface Props {
    children?: React.ReactNode;
}

function CardDetails({ children }: Props): ReactElement {
    return <span className="text-xs text-ce-gray-800">{children}</span>;
}

export default CardDetails;
